import React, { useState } from "react";

function AddTripEntry({ onSubmit }) {
  const [formData, setFormData] = useState({
    trip: "",
    route: "",
    bus: "",
    driver: "",
    tripDate: "",
    startTime: "",
    endTime: "",
    status: "Scheduled",
    Description: "",
    isRoundTrip: false, // New field to indicate round trip
    returnStartTime: "",
    returnEndTime: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with data: ", formData);
    onSubmit(formData);
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="trip" className="form-label">
                Trip Id
              </label>
              <input
                type="text"
                className="form-control"
                id="trip"
                name="trip"
                value={formData.trip}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="route" className="form-label">
                Route
              </label>
              <select
                className="form-select"
                id="route"
                name="route"
                value={formData.route}
                onChange={handleChange}
                required
              >
                <option value="">Select Route</option>
                <option value="Route 1">Route 1</option>
                <option value="Route 2">Route 2</option>
                <option value="Route 3">Route 3</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="bus" className="form-label">
                Bus
              </label>
              <select
                className="form-select"
                id="bus"
                name="bus"
                value={formData.bus}
                onChange={handleChange}
                required
              >
                <option value="">Select Bus</option>
                <option value="TN01AB1234">TN01AB1234</option>
                <option value="TN01AB5678">TN01AB5678</option>
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="driver" className="form-label">
                Driver
              </label>
              <select
                className="form-select"
                id="driver"
                name="driver"
                value={formData.driver}
                onChange={handleChange}
                required
              >
                <option value="">Select Driver</option>
                <option value="John Doe">John Doe</option>
                <option value="Jane Smith">Jane Smith</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="startTime" className="form-label">
                Start Time
              </label>
              <input
                type="time"
                className="form-control"
                id="startTime"
                name="startTime"
                value={formData.startTime}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="endTime" className="form-label">
                End Time
              </label>
              <input
                type="time"
                className="form-control"
                id="endTime"
                name="endTime"
                value={formData.endTime}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="tripDate" className="form-label">
                Trip Date
              </label>
              <input
                type="date"
                className="form-control"
                id="tripDate"
                name="tripDate"
                value={formData.tripDate}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6 ">
          <div className="form-check mb-3 mt-5 ">
          <input
            type="checkbox"
            className="form-check-input"
            id="isRoundTrip"
            name="isRoundTrip"
            checked={formData.isRoundTrip}
            onChange={handleChange}
          />
          <label htmlFor="isRoundTrip" className="form-check-label">
            Is this a round trip?
          </label>
        </div>
        </div>

        </div>

       
        {formData.isRoundTrip && (
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="returnStartTime" className="form-label">
                  Return Start Time
                </label>
                <input
                  type="time"
                  className="form-control"
                  id="returnStartTime"
                  name="returnStartTime"
                  value={formData.returnStartTime}
                  onChange={handleChange}
                  required={formData.isRoundTrip}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="returnEndTime" className="form-label">
                  Return End Time
                </label>
                <input
                  type="time"
                  className="form-control"
                  id="returnEndTime"
                  name="returnEndTime"
                  value={formData.returnEndTime}
                  onChange={handleChange}
                  required={formData.isRoundTrip}
                />
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="status" className="form-label">
                Status
              </label>
              <select
                className="form-select"
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="Scheduled">Scheduled</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="Description" className="form-label">
                Description
              </label>
              <input
                type="text"
                className="form-control"
                id="Description"
                name="Description"
                value={formData.Description}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

       
        <div className="text-center">
          <button type="submit" className="btn btn-primary mt-4">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddTripEntry;
